/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InvestmentStyleDiagnosisAgentAllOf from './InvestmentStyleDiagnosisAgentAllOf';
import InvestmentStyleDiagnosisAgentAllOfAnswerLabels from './InvestmentStyleDiagnosisAgentAllOfAnswerLabels';
import InvestmentStyleDiagnosisAnxietyScore from './InvestmentStyleDiagnosisAnxietyScore';
import InvestmentStyleDiagnosisInterestScore from './InvestmentStyleDiagnosisInterestScore';
import InvestmentStyleDiagnosisMeetingQuestion from './InvestmentStyleDiagnosisMeetingQuestion';
import InvestmentStyleDiagnosisPlannerAnswers from './InvestmentStyleDiagnosisPlannerAnswers';
import InvestmentStyleDiagnosisResult from './InvestmentStyleDiagnosisResult';

/**
 * The InvestmentStyleDiagnosisAgent model module.
 * @module model/InvestmentStyleDiagnosisAgent
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisAgent {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisAgent</code>.
     * プランナー向け診断。家賃収入の使いみち・働き方の見通しは値・ラベルとも非公開。
     * @alias module:model/InvestmentStyleDiagnosisAgent
     * @implements module:model/InvestmentStyleDiagnosisPlannerAnswers
     * @implements module:model/InvestmentStyleDiagnosisResult
     * @implements module:model/InvestmentStyleDiagnosisAgentAllOf
     */
    constructor() { 
        InvestmentStyleDiagnosisPlannerAnswers.initialize(this);InvestmentStyleDiagnosisResult.initialize(this);InvestmentStyleDiagnosisAgentAllOf.initialize(this);
        InvestmentStyleDiagnosisAgent.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisAgent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisAgent} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisAgent} The populated <code>InvestmentStyleDiagnosisAgent</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisAgent();
            InvestmentStyleDiagnosisPlannerAnswers.constructFromObject(data, obj);
            InvestmentStyleDiagnosisResult.constructFromObject(data, obj);
            InvestmentStyleDiagnosisAgentAllOf.constructFromObject(data, obj);

            if (data.hasOwnProperty('purposes')) {
                obj['purposes'] = ApiClient.convertToType(data['purposes'], ['String']);
            }
            if (data.hasOwnProperty('primary_purpose')) {
                obj['primary_purpose'] = ApiClient.convertToType(data['primary_purpose'], 'String');
            }
            if (data.hasOwnProperty('ideal_text')) {
                obj['ideal_text'] = ApiClient.convertToType(data['ideal_text'], 'String');
            }
            if (data.hasOwnProperty('target_monthly_income')) {
                obj['target_monthly_income'] = ApiClient.convertToType(data['target_monthly_income'], 'String');
            }
            if (data.hasOwnProperty('interest_1st')) {
                obj['interest_1st'] = ApiClient.convertToType(data['interest_1st'], 'String');
            }
            if (data.hasOwnProperty('interest_2nd')) {
                obj['interest_2nd'] = ApiClient.convertToType(data['interest_2nd'], 'String');
            }
            if (data.hasOwnProperty('interest_3rd')) {
                obj['interest_3rd'] = ApiClient.convertToType(data['interest_3rd'], 'String');
            }
            if (data.hasOwnProperty('success_conditions')) {
                obj['success_conditions'] = ApiClient.convertToType(data['success_conditions'], ['String']);
            }
            if (data.hasOwnProperty('monthly_out_of_pocket')) {
                obj['monthly_out_of_pocket'] = ApiClient.convertToType(data['monthly_out_of_pocket'], 'String');
            }
            if (data.hasOwnProperty('borrowing_stance')) {
                obj['borrowing_stance'] = ApiClient.convertToType(data['borrowing_stance'], 'String');
            }
            if (data.hasOwnProperty('holding_period')) {
                obj['holding_period'] = ApiClient.convertToType(data['holding_period'], 'String');
            }
            if (data.hasOwnProperty('location_yield_preference')) {
                obj['location_yield_preference'] = ApiClient.convertToType(data['location_yield_preference'], 'Number');
            }
            if (data.hasOwnProperty('management_style')) {
                obj['management_style'] = ApiClient.convertToType(data['management_style'], 'String');
            }
            if (data.hasOwnProperty('short_term_sale_intent')) {
                obj['short_term_sale_intent'] = ApiClient.convertToType(data['short_term_sale_intent'], 'String');
            }
            if (data.hasOwnProperty('first_purchase_timing')) {
                obj['first_purchase_timing'] = ApiClient.convertToType(data['first_purchase_timing'], 'String');
            }
            if (data.hasOwnProperty('planner_comparison_count')) {
                obj['planner_comparison_count'] = ApiClient.convertToType(data['planner_comparison_count'], 'String');
            }
            if (data.hasOwnProperty('meeting_check_items')) {
                obj['meeting_check_items'] = ApiClient.convertToType(data['meeting_check_items'], ['String']);
            }
            if (data.hasOwnProperty('explanation_styles')) {
                obj['explanation_styles'] = ApiClient.convertToType(data['explanation_styles'], ['String']);
            }
            if (data.hasOwnProperty('meeting_free_text')) {
                obj['meeting_free_text'] = ApiClient.convertToType(data['meeting_free_text'], 'String');
            }
            if (data.hasOwnProperty('anxiety_loan')) {
                obj['anxiety_loan'] = ApiClient.convertToType(data['anxiety_loan'], 'String');
            }
            if (data.hasOwnProperty('anxiety_vacancy')) {
                obj['anxiety_vacancy'] = ApiClient.convertToType(data['anxiety_vacancy'], 'String');
            }
            if (data.hasOwnProperty('anxiety_exit')) {
                obj['anxiety_exit'] = ApiClient.convertToType(data['anxiety_exit'], 'String');
            }
            if (data.hasOwnProperty('anxiety_repair')) {
                obj['anxiety_repair'] = ApiClient.convertToType(data['anxiety_repair'], 'String');
            }
            if (data.hasOwnProperty('anxiety_sales_pressure')) {
                obj['anxiety_sales_pressure'] = ApiClient.convertToType(data['anxiety_sales_pressure'], 'String');
            }
            if (data.hasOwnProperty('avoid_sales_styles')) {
                obj['avoid_sales_styles'] = ApiClient.convertToType(data['avoid_sales_styles'], ['String']);
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('customer_type')) {
                obj['customer_type'] = ApiClient.convertToType(data['customer_type'], 'String');
            }
            if (data.hasOwnProperty('core_goal')) {
                obj['core_goal'] = ApiClient.convertToType(data['core_goal'], 'String');
            }
            if (data.hasOwnProperty('interest_scores')) {
                obj['interest_scores'] = ApiClient.convertToType(data['interest_scores'], [InvestmentStyleDiagnosisInterestScore]);
            }
            if (data.hasOwnProperty('suited_assets')) {
                obj['suited_assets'] = ApiClient.convertToType(data['suited_assets'], ['String']);
            }
            if (data.hasOwnProperty('meeting_questions')) {
                obj['meeting_questions'] = ApiClient.convertToType(data['meeting_questions'], [InvestmentStyleDiagnosisMeetingQuestion]);
            }
            if (data.hasOwnProperty('anxiety_scores')) {
                obj['anxiety_scores'] = ApiClient.convertToType(data['anxiety_scores'], [InvestmentStyleDiagnosisAnxietyScore]);
            }
            if (data.hasOwnProperty('avoid_sales_style_warnings')) {
                obj['avoid_sales_style_warnings'] = ApiClient.convertToType(data['avoid_sales_style_warnings'], ['String']);
            }
            if (data.hasOwnProperty('needs_safety_content')) {
                obj['needs_safety_content'] = ApiClient.convertToType(data['needs_safety_content'], 'Boolean');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('answer_labels')) {
                obj['answer_labels'] = InvestmentStyleDiagnosisAgentAllOfAnswerLabels.constructFromObject(data['answer_labels']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisAgent</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisAgent</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['purposes'])) {
            throw new Error("Expected the field `purposes` to be an array in the JSON data but got " + data['purposes']);
        }
        // ensure the json data is a string
        if (data['primary_purpose'] && !(typeof data['primary_purpose'] === 'string' || data['primary_purpose'] instanceof String)) {
            throw new Error("Expected the field `primary_purpose` to be a primitive type in the JSON string but got " + data['primary_purpose']);
        }
        // ensure the json data is a string
        if (data['ideal_text'] && !(typeof data['ideal_text'] === 'string' || data['ideal_text'] instanceof String)) {
            throw new Error("Expected the field `ideal_text` to be a primitive type in the JSON string but got " + data['ideal_text']);
        }
        // ensure the json data is a string
        if (data['target_monthly_income'] && !(typeof data['target_monthly_income'] === 'string' || data['target_monthly_income'] instanceof String)) {
            throw new Error("Expected the field `target_monthly_income` to be a primitive type in the JSON string but got " + data['target_monthly_income']);
        }
        // ensure the json data is a string
        if (data['interest_1st'] && !(typeof data['interest_1st'] === 'string' || data['interest_1st'] instanceof String)) {
            throw new Error("Expected the field `interest_1st` to be a primitive type in the JSON string but got " + data['interest_1st']);
        }
        // ensure the json data is a string
        if (data['interest_2nd'] && !(typeof data['interest_2nd'] === 'string' || data['interest_2nd'] instanceof String)) {
            throw new Error("Expected the field `interest_2nd` to be a primitive type in the JSON string but got " + data['interest_2nd']);
        }
        // ensure the json data is a string
        if (data['interest_3rd'] && !(typeof data['interest_3rd'] === 'string' || data['interest_3rd'] instanceof String)) {
            throw new Error("Expected the field `interest_3rd` to be a primitive type in the JSON string but got " + data['interest_3rd']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['success_conditions'])) {
            throw new Error("Expected the field `success_conditions` to be an array in the JSON data but got " + data['success_conditions']);
        }
        // ensure the json data is a string
        if (data['monthly_out_of_pocket'] && !(typeof data['monthly_out_of_pocket'] === 'string' || data['monthly_out_of_pocket'] instanceof String)) {
            throw new Error("Expected the field `monthly_out_of_pocket` to be a primitive type in the JSON string but got " + data['monthly_out_of_pocket']);
        }
        // ensure the json data is a string
        if (data['borrowing_stance'] && !(typeof data['borrowing_stance'] === 'string' || data['borrowing_stance'] instanceof String)) {
            throw new Error("Expected the field `borrowing_stance` to be a primitive type in the JSON string but got " + data['borrowing_stance']);
        }
        // ensure the json data is a string
        if (data['holding_period'] && !(typeof data['holding_period'] === 'string' || data['holding_period'] instanceof String)) {
            throw new Error("Expected the field `holding_period` to be a primitive type in the JSON string but got " + data['holding_period']);
        }
        // ensure the json data is a string
        if (data['management_style'] && !(typeof data['management_style'] === 'string' || data['management_style'] instanceof String)) {
            throw new Error("Expected the field `management_style` to be a primitive type in the JSON string but got " + data['management_style']);
        }
        // ensure the json data is a string
        if (data['short_term_sale_intent'] && !(typeof data['short_term_sale_intent'] === 'string' || data['short_term_sale_intent'] instanceof String)) {
            throw new Error("Expected the field `short_term_sale_intent` to be a primitive type in the JSON string but got " + data['short_term_sale_intent']);
        }
        // ensure the json data is a string
        if (data['first_purchase_timing'] && !(typeof data['first_purchase_timing'] === 'string' || data['first_purchase_timing'] instanceof String)) {
            throw new Error("Expected the field `first_purchase_timing` to be a primitive type in the JSON string but got " + data['first_purchase_timing']);
        }
        // ensure the json data is a string
        if (data['planner_comparison_count'] && !(typeof data['planner_comparison_count'] === 'string' || data['planner_comparison_count'] instanceof String)) {
            throw new Error("Expected the field `planner_comparison_count` to be a primitive type in the JSON string but got " + data['planner_comparison_count']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['meeting_check_items'])) {
            throw new Error("Expected the field `meeting_check_items` to be an array in the JSON data but got " + data['meeting_check_items']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['explanation_styles'])) {
            throw new Error("Expected the field `explanation_styles` to be an array in the JSON data but got " + data['explanation_styles']);
        }
        // ensure the json data is a string
        if (data['meeting_free_text'] && !(typeof data['meeting_free_text'] === 'string' || data['meeting_free_text'] instanceof String)) {
            throw new Error("Expected the field `meeting_free_text` to be a primitive type in the JSON string but got " + data['meeting_free_text']);
        }
        // ensure the json data is a string
        if (data['anxiety_loan'] && !(typeof data['anxiety_loan'] === 'string' || data['anxiety_loan'] instanceof String)) {
            throw new Error("Expected the field `anxiety_loan` to be a primitive type in the JSON string but got " + data['anxiety_loan']);
        }
        // ensure the json data is a string
        if (data['anxiety_vacancy'] && !(typeof data['anxiety_vacancy'] === 'string' || data['anxiety_vacancy'] instanceof String)) {
            throw new Error("Expected the field `anxiety_vacancy` to be a primitive type in the JSON string but got " + data['anxiety_vacancy']);
        }
        // ensure the json data is a string
        if (data['anxiety_exit'] && !(typeof data['anxiety_exit'] === 'string' || data['anxiety_exit'] instanceof String)) {
            throw new Error("Expected the field `anxiety_exit` to be a primitive type in the JSON string but got " + data['anxiety_exit']);
        }
        // ensure the json data is a string
        if (data['anxiety_repair'] && !(typeof data['anxiety_repair'] === 'string' || data['anxiety_repair'] instanceof String)) {
            throw new Error("Expected the field `anxiety_repair` to be a primitive type in the JSON string but got " + data['anxiety_repair']);
        }
        // ensure the json data is a string
        if (data['anxiety_sales_pressure'] && !(typeof data['anxiety_sales_pressure'] === 'string' || data['anxiety_sales_pressure'] instanceof String)) {
            throw new Error("Expected the field `anxiety_sales_pressure` to be a primitive type in the JSON string but got " + data['anxiety_sales_pressure']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['avoid_sales_styles'])) {
            throw new Error("Expected the field `avoid_sales_styles` to be an array in the JSON data but got " + data['avoid_sales_styles']);
        }
        // ensure the json data is a string
        if (data['customer_type'] && !(typeof data['customer_type'] === 'string' || data['customer_type'] instanceof String)) {
            throw new Error("Expected the field `customer_type` to be a primitive type in the JSON string but got " + data['customer_type']);
        }
        // ensure the json data is a string
        if (data['core_goal'] && !(typeof data['core_goal'] === 'string' || data['core_goal'] instanceof String)) {
            throw new Error("Expected the field `core_goal` to be a primitive type in the JSON string but got " + data['core_goal']);
        }
        if (data['interest_scores']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['interest_scores'])) {
                throw new Error("Expected the field `interest_scores` to be an array in the JSON data but got " + data['interest_scores']);
            }
            // validate the optional field `interest_scores` (array)
            for (const item of data['interest_scores']) {
                InvestmentStyleDiagnosisInterestScore.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['suited_assets'])) {
            throw new Error("Expected the field `suited_assets` to be an array in the JSON data but got " + data['suited_assets']);
        }
        if (data['meeting_questions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['meeting_questions'])) {
                throw new Error("Expected the field `meeting_questions` to be an array in the JSON data but got " + data['meeting_questions']);
            }
            // validate the optional field `meeting_questions` (array)
            for (const item of data['meeting_questions']) {
                InvestmentStyleDiagnosisMeetingQuestion.validateJSON(item);
            };
        }
        if (data['anxiety_scores']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['anxiety_scores'])) {
                throw new Error("Expected the field `anxiety_scores` to be an array in the JSON data but got " + data['anxiety_scores']);
            }
            // validate the optional field `anxiety_scores` (array)
            for (const item of data['anxiety_scores']) {
                InvestmentStyleDiagnosisAnxietyScore.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['avoid_sales_style_warnings'])) {
            throw new Error("Expected the field `avoid_sales_style_warnings` to be an array in the JSON data but got " + data['avoid_sales_style_warnings']);
        }
        // validate the optional field `answer_labels`
        if (data['answer_labels']) { // data not null
          InvestmentStyleDiagnosisAgentAllOfAnswerLabels.validateJSON(data['answer_labels']);
        }

        return true;
    }


}



/**
 * 投資目的（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.PurposesEnum>} purposes
 */
InvestmentStyleDiagnosisAgent.prototype['purposes'] = undefined;

/**
 * 最も重要な投資目的
 * @member {module:model/InvestmentStyleDiagnosisAgent.PrimaryPurposeEnum} primary_purpose
 */
InvestmentStyleDiagnosisAgent.prototype['primary_purpose'] = undefined;

/**
 * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
 * @member {String} ideal_text
 */
InvestmentStyleDiagnosisAgent.prototype['ideal_text'] = undefined;

/**
 * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisAgent.TargetMonthlyIncomeEnum} target_monthly_income
 */
InvestmentStyleDiagnosisAgent.prototype['target_monthly_income'] = undefined;

/**
 * 関心事項1位
 * @member {module:model/InvestmentStyleDiagnosisAgent.Interest1stEnum} interest_1st
 */
InvestmentStyleDiagnosisAgent.prototype['interest_1st'] = undefined;

/**
 * 関心事項2位
 * @member {module:model/InvestmentStyleDiagnosisAgent.Interest2ndEnum} interest_2nd
 */
InvestmentStyleDiagnosisAgent.prototype['interest_2nd'] = undefined;

/**
 * 関心事項3位
 * @member {module:model/InvestmentStyleDiagnosisAgent.Interest3rdEnum} interest_3rd
 */
InvestmentStyleDiagnosisAgent.prototype['interest_3rd'] = undefined;

/**
 * 成功条件（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.SuccessConditionsEnum>} success_conditions
 */
InvestmentStyleDiagnosisAgent.prototype['success_conditions'] = undefined;

/**
 * 毎月の持ち出し許容額
 * @member {module:model/InvestmentStyleDiagnosisAgent.MonthlyOutOfPocketEnum} monthly_out_of_pocket
 */
InvestmentStyleDiagnosisAgent.prototype['monthly_out_of_pocket'] = undefined;

/**
 * 借入についての考え方。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisAgent.BorrowingStanceEnum} borrowing_stance
 */
InvestmentStyleDiagnosisAgent.prototype['borrowing_stance'] = undefined;

/**
 * 保有期間の想定
 * @member {module:model/InvestmentStyleDiagnosisAgent.HoldingPeriodEnum} holding_period
 */
InvestmentStyleDiagnosisAgent.prototype['holding_period'] = undefined;

/**
 * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
 * @member {Number} location_yield_preference
 */
InvestmentStyleDiagnosisAgent.prototype['location_yield_preference'] = undefined;

/**
 * 運用スタイル
 * @member {module:model/InvestmentStyleDiagnosisAgent.ManagementStyleEnum} management_style
 */
InvestmentStyleDiagnosisAgent.prototype['management_style'] = undefined;

/**
 * 売却タイミングの考え方
 * @member {module:model/InvestmentStyleDiagnosisAgent.ShortTermSaleIntentEnum} short_term_sale_intent
 */
InvestmentStyleDiagnosisAgent.prototype['short_term_sale_intent'] = undefined;

/**
 * 1件目の時期。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisAgent.FirstPurchaseTimingEnum} first_purchase_timing
 */
InvestmentStyleDiagnosisAgent.prototype['first_purchase_timing'] = undefined;

/**
 * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisAgent.PlannerComparisonCountEnum} planner_comparison_count
 */
InvestmentStyleDiagnosisAgent.prototype['planner_comparison_count'] = undefined;

/**
 * 面談で確認したいこと（複数選択・配列順が選択順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.MeetingCheckItemsEnum>} meeting_check_items
 */
InvestmentStyleDiagnosisAgent.prototype['meeting_check_items'] = undefined;

/**
 * 希望する説明方法（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.ExplanationStylesEnum>} explanation_styles
 */
InvestmentStyleDiagnosisAgent.prototype['explanation_styles'] = undefined;

/**
 * 面談で聞きたいこと（自由記述）
 * @member {String} meeting_free_text
 */
InvestmentStyleDiagnosisAgent.prototype['meeting_free_text'] = undefined;

/**
 * 不安要素：ローン負担
 * @member {module:model/InvestmentStyleDiagnosisAgent.AnxietyLoanEnum} anxiety_loan
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_loan'] = undefined;

/**
 * 不安要素：空室
 * @member {module:model/InvestmentStyleDiagnosisAgent.AnxietyVacancyEnum} anxiety_vacancy
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_vacancy'] = undefined;

/**
 * 不安要素：出口・売却
 * @member {module:model/InvestmentStyleDiagnosisAgent.AnxietyExitEnum} anxiety_exit
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_exit'] = undefined;

/**
 * 不安要素：修繕費
 * @member {module:model/InvestmentStyleDiagnosisAgent.AnxietyRepairEnum} anxiety_repair
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_repair'] = undefined;

/**
 * 不安要素：営業に流されること
 * @member {module:model/InvestmentStyleDiagnosisAgent.AnxietySalesPressureEnum} anxiety_sales_pressure
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_sales_pressure'] = undefined;

/**
 * 避けたい営業スタイル（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.AvoidSalesStylesEnum>} avoid_sales_styles
 */
InvestmentStyleDiagnosisAgent.prototype['avoid_sales_styles'] = undefined;

/**
 * @member {Number} id
 */
InvestmentStyleDiagnosisAgent.prototype['id'] = undefined;

/**
 * お客様タイプ
 * @member {module:model/InvestmentStyleDiagnosisAgent.CustomerTypeEnum} customer_type
 */
InvestmentStyleDiagnosisAgent.prototype['customer_type'] = undefined;

/**
 * 診断から導出した中心的な投資目的
 * @member {module:model/InvestmentStyleDiagnosisAgent.CoreGoalEnum} core_goal
 */
InvestmentStyleDiagnosisAgent.prototype['core_goal'] = undefined;

/**
 * 関心グラフ（スコア降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisInterestScore>} interest_scores
 */
InvestmentStyleDiagnosisAgent.prototype['interest_scores'] = undefined;

/**
 * 向いているアセット（おすすめ順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.SuitedAssetsEnum>} suited_assets
 */
InvestmentStyleDiagnosisAgent.prototype['suited_assets'] = undefined;

/**
 * 面談で聞くと良い質問（最大5件・表示順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisMeetingQuestion>} meeting_questions
 */
InvestmentStyleDiagnosisAgent.prototype['meeting_questions'] = undefined;

/**
 * 不安項目（降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAnxietyScore>} anxiety_scores
 */
InvestmentStyleDiagnosisAgent.prototype['anxiety_scores'] = undefined;

/**
 * 避けるべき進め方の警告（重要度順・最大2件）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAgent.AvoidSalesStyleWarningsEnum>} avoid_sales_style_warnings
 */
InvestmentStyleDiagnosisAgent.prototype['avoid_sales_style_warnings'] = undefined;

/**
 * 安全装置フラグ（強い不安が3つ以上）
 * @member {Boolean} needs_safety_content
 */
InvestmentStyleDiagnosisAgent.prototype['needs_safety_content'] = undefined;

/**
 * 診断完了日時（作成日時）
 * @member {Date} created_at
 */
InvestmentStyleDiagnosisAgent.prototype['created_at'] = undefined;

/**
 * @member {module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels} answer_labels
 */
InvestmentStyleDiagnosisAgent.prototype['answer_labels'] = undefined;


// Implement InvestmentStyleDiagnosisPlannerAnswers interface:
/**
 * 投資目的（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisPlannerAnswers.PurposesEnum>} purposes
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['purposes'] = undefined;
/**
 * 最も重要な投資目的
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.PrimaryPurposeEnum} primary_purpose
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['primary_purpose'] = undefined;
/**
 * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
 * @member {String} ideal_text
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['ideal_text'] = undefined;
/**
 * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.TargetMonthlyIncomeEnum} target_monthly_income
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['target_monthly_income'] = undefined;
/**
 * 関心事項1位
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.Interest1stEnum} interest_1st
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['interest_1st'] = undefined;
/**
 * 関心事項2位
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.Interest2ndEnum} interest_2nd
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['interest_2nd'] = undefined;
/**
 * 関心事項3位
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.Interest3rdEnum} interest_3rd
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['interest_3rd'] = undefined;
/**
 * 成功条件（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisPlannerAnswers.SuccessConditionsEnum>} success_conditions
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['success_conditions'] = undefined;
/**
 * 毎月の持ち出し許容額
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.MonthlyOutOfPocketEnum} monthly_out_of_pocket
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['monthly_out_of_pocket'] = undefined;
/**
 * 借入についての考え方。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.BorrowingStanceEnum} borrowing_stance
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['borrowing_stance'] = undefined;
/**
 * 保有期間の想定
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.HoldingPeriodEnum} holding_period
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['holding_period'] = undefined;
/**
 * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
 * @member {Number} location_yield_preference
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['location_yield_preference'] = undefined;
/**
 * 運用スタイル
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.ManagementStyleEnum} management_style
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['management_style'] = undefined;
/**
 * 売却タイミングの考え方
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.ShortTermSaleIntentEnum} short_term_sale_intent
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['short_term_sale_intent'] = undefined;
/**
 * 1件目の時期。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.FirstPurchaseTimingEnum} first_purchase_timing
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['first_purchase_timing'] = undefined;
/**
 * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.PlannerComparisonCountEnum} planner_comparison_count
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['planner_comparison_count'] = undefined;
/**
 * 面談で確認したいこと（複数選択・配列順が選択順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisPlannerAnswers.MeetingCheckItemsEnum>} meeting_check_items
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['meeting_check_items'] = undefined;
/**
 * 希望する説明方法（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisPlannerAnswers.ExplanationStylesEnum>} explanation_styles
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['explanation_styles'] = undefined;
/**
 * 面談で聞きたいこと（自由記述）
 * @member {String} meeting_free_text
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['meeting_free_text'] = undefined;
/**
 * 不安要素：ローン負担
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.AnxietyLoanEnum} anxiety_loan
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['anxiety_loan'] = undefined;
/**
 * 不安要素：空室
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.AnxietyVacancyEnum} anxiety_vacancy
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['anxiety_vacancy'] = undefined;
/**
 * 不安要素：出口・売却
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.AnxietyExitEnum} anxiety_exit
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['anxiety_exit'] = undefined;
/**
 * 不安要素：修繕費
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.AnxietyRepairEnum} anxiety_repair
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['anxiety_repair'] = undefined;
/**
 * 不安要素：営業に流されること
 * @member {module:model/InvestmentStyleDiagnosisPlannerAnswers.AnxietySalesPressureEnum} anxiety_sales_pressure
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['anxiety_sales_pressure'] = undefined;
/**
 * 避けたい営業スタイル（複数選択）
 * @member {Array.<module:model/InvestmentStyleDiagnosisPlannerAnswers.AvoidSalesStylesEnum>} avoid_sales_styles
 */
InvestmentStyleDiagnosisPlannerAnswers.prototype['avoid_sales_styles'] = undefined;
// Implement InvestmentStyleDiagnosisResult interface:
/**
 * @member {Number} id
 */
InvestmentStyleDiagnosisResult.prototype['id'] = undefined;
/**
 * お客様タイプ
 * @member {module:model/InvestmentStyleDiagnosisResult.CustomerTypeEnum} customer_type
 */
InvestmentStyleDiagnosisResult.prototype['customer_type'] = undefined;
/**
 * 診断から導出した中心的な投資目的
 * @member {module:model/InvestmentStyleDiagnosisResult.CoreGoalEnum} core_goal
 */
InvestmentStyleDiagnosisResult.prototype['core_goal'] = undefined;
/**
 * 関心グラフ（スコア降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisInterestScore>} interest_scores
 */
InvestmentStyleDiagnosisResult.prototype['interest_scores'] = undefined;
/**
 * 向いているアセット（おすすめ順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisResult.SuitedAssetsEnum>} suited_assets
 */
InvestmentStyleDiagnosisResult.prototype['suited_assets'] = undefined;
/**
 * 面談で聞くと良い質問（最大5件・表示順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisMeetingQuestion>} meeting_questions
 */
InvestmentStyleDiagnosisResult.prototype['meeting_questions'] = undefined;
/**
 * 不安項目（降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAnxietyScore>} anxiety_scores
 */
InvestmentStyleDiagnosisResult.prototype['anxiety_scores'] = undefined;
/**
 * 避けるべき進め方の警告（重要度順・最大2件）
 * @member {Array.<module:model/InvestmentStyleDiagnosisResult.AvoidSalesStyleWarningsEnum>} avoid_sales_style_warnings
 */
InvestmentStyleDiagnosisResult.prototype['avoid_sales_style_warnings'] = undefined;
/**
 * 安全装置フラグ（強い不安が3つ以上）
 * @member {Boolean} needs_safety_content
 */
InvestmentStyleDiagnosisResult.prototype['needs_safety_content'] = undefined;
/**
 * 診断完了日時（作成日時）
 * @member {Date} created_at
 */
InvestmentStyleDiagnosisResult.prototype['created_at'] = undefined;
// Implement InvestmentStyleDiagnosisAgentAllOf interface:
/**
 * @member {module:model/InvestmentStyleDiagnosisAgentAllOfAnswerLabels} answer_labels
 */
InvestmentStyleDiagnosisAgentAllOf.prototype['answer_labels'] = undefined;



/**
 * Allowed values for the <code>purposes</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['PurposesEnum'] = {

    /**
     * value: "retirement_income"
     * @const
     */
    "retirement_income": "retirement_income",

    /**
     * value: "inflation_hedge"
     * @const
     */
    "inflation_hedge": "inflation_hedge",

    /**
     * value: "life_insurance"
     * @const
     */
    "life_insurance": "life_insurance",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "side_income"
     * @const
     */
    "side_income": "side_income",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain"
};


/**
 * Allowed values for the <code>primary_purpose</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['PrimaryPurposeEnum'] = {

    /**
     * value: "retirement_income"
     * @const
     */
    "retirement_income": "retirement_income",

    /**
     * value: "inflation_hedge"
     * @const
     */
    "inflation_hedge": "inflation_hedge",

    /**
     * value: "life_insurance"
     * @const
     */
    "life_insurance": "life_insurance",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "side_income"
     * @const
     */
    "side_income": "side_income",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain"
};


/**
 * Allowed values for the <code>target_monthly_income</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['TargetMonthlyIncomeEnum'] = {

    /**
     * value: "plus_30k"
     * @const
     */
    "plus_30k": "plus_30k",

    /**
     * value: "plus_50k"
     * @const
     */
    "plus_50k": "plus_50k",

    /**
     * value: "plus_100k"
     * @const
     */
    "plus_100k": "plus_100k",

    /**
     * value: "plus_150k_or_more"
     * @const
     */
    "plus_150k_or_more": "plus_150k_or_more",

    /**
     * value: "undecided"
     * @const
     */
    "undecided": "undecided"
};


/**
 * Allowed values for the <code>interest_1st</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['Interest1stEnum'] = {

    /**
     * value: "stable_income"
     * @const
     */
    "stable_income": "stable_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "high_yield"
     * @const
     */
    "high_yield": "high_yield",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "loss_avoidance_safety"
     * @const
     */
    "loss_avoidance_safety": "loss_avoidance_safety",

    /**
     * value: "loss_avoidance_low_initial"
     * @const
     */
    "loss_avoidance_low_initial": "loss_avoidance_low_initial",

    /**
     * value: "loss_avoidance_trusted"
     * @const
     */
    "loss_avoidance_trusted": "loss_avoidance_trusted"
};


/**
 * Allowed values for the <code>interest_2nd</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['Interest2ndEnum'] = {

    /**
     * value: "stable_income"
     * @const
     */
    "stable_income": "stable_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "high_yield"
     * @const
     */
    "high_yield": "high_yield",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "loss_avoidance_safety"
     * @const
     */
    "loss_avoidance_safety": "loss_avoidance_safety",

    /**
     * value: "loss_avoidance_low_initial"
     * @const
     */
    "loss_avoidance_low_initial": "loss_avoidance_low_initial",

    /**
     * value: "loss_avoidance_trusted"
     * @const
     */
    "loss_avoidance_trusted": "loss_avoidance_trusted"
};


/**
 * Allowed values for the <code>interest_3rd</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['Interest3rdEnum'] = {

    /**
     * value: "stable_income"
     * @const
     */
    "stable_income": "stable_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "high_yield"
     * @const
     */
    "high_yield": "high_yield",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "loss_avoidance_safety"
     * @const
     */
    "loss_avoidance_safety": "loss_avoidance_safety",

    /**
     * value: "loss_avoidance_low_initial"
     * @const
     */
    "loss_avoidance_low_initial": "loss_avoidance_low_initial",

    /**
     * value: "loss_avoidance_trusted"
     * @const
     */
    "loss_avoidance_trusted": "loss_avoidance_trusted"
};


/**
 * Allowed values for the <code>successConditions</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['SuccessConditionsEnum'] = {

    /**
     * value: "retirement_monthly"
     * @const
     */
    "retirement_monthly": "retirement_monthly",

    /**
     * value: "debt_free_asset"
     * @const
     */
    "debt_free_asset": "debt_free_asset",

    /**
     * value: "avoid_big_loss"
     * @const
     */
    "avoid_big_loss": "avoid_big_loss",

    /**
     * value: "able_to_expand"
     * @const
     */
    "able_to_expand": "able_to_expand",

    /**
     * value: "tax_achieved"
     * @const
     */
    "tax_achieved": "tax_achieved"
};


/**
 * Allowed values for the <code>monthly_out_of_pocket</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['MonthlyOutOfPocketEnum'] = {

    /**
     * value: "near_zero"
     * @const
     */
    "near_zero": "near_zero",

    /**
     * value: "within_5k"
     * @const
     */
    "within_5k": "within_5k",

    /**
     * value: "within_10k"
     * @const
     */
    "within_10k": "within_10k",

    /**
     * value: "within_30k"
     * @const
     */
    "within_30k": "within_30k",

    /**
     * value: "within_50k"
     * @const
     */
    "within_50k": "within_50k",

    /**
     * value: "over_50k"
     * @const
     */
    "over_50k": "over_50k"
};


/**
 * Allowed values for the <code>borrowing_stance</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['BorrowingStanceEnum'] = {

    /**
     * value: "start_small_first_loan"
     * @const
     */
    "start_small_first_loan": "start_small_first_loan",

    /**
     * value: "ok_if_rent_covers"
     * @const
     */
    "ok_if_rent_covers": "ok_if_rent_covers",

    /**
     * value: "anxious_with_mortgage"
     * @const
     */
    "anxious_with_mortgage": "anxious_with_mortgage",

    /**
     * value: "start_big_if_possible"
     * @const
     */
    "start_big_if_possible": "start_big_if_possible",

    /**
     * value: "unsure_eligibility"
     * @const
     */
    "unsure_eligibility": "unsure_eligibility"
};


/**
 * Allowed values for the <code>holding_period</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['HoldingPeriodEnum'] = {

    /**
     * value: "within_5y"
     * @const
     */
    "within_5y": "within_5y",

    /**
     * value: "about_10y"
     * @const
     */
    "about_10y": "about_10y",

    /**
     * value: "about_20y"
     * @const
     */
    "about_20y": "about_20y",

    /**
     * value: "about_30y"
     * @const
     */
    "about_30y": "about_30y",

    /**
     * value: "after_payoff"
     * @const
     */
    "after_payoff": "after_payoff"
};


/**
 * Allowed values for the <code>management_style</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['ManagementStyleEnum'] = {

    /**
     * value: "fully_delegated"
     * @const
     */
    "fully_delegated": "fully_delegated",

    /**
     * value: "delegated_with_report"
     * @const
     */
    "delegated_with_report": "delegated_with_report",

    /**
     * value: "key_decisions_only"
     * @const
     */
    "key_decisions_only": "key_decisions_only",

    /**
     * value: "self_directed"
     * @const
     */
    "self_directed": "self_directed",

    /**
     * value: "active_landlord"
     * @const
     */
    "active_landlord": "active_landlord"
};


/**
 * Allowed values for the <code>short_term_sale_intent</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['ShortTermSaleIntentEnum'] = {

    /**
     * value: "yes"
     * @const
     */
    "yes": "yes",

    /**
     * value: "conditional"
     * @const
     */
    "conditional": "conditional",

    /**
     * value: "no"
     * @const
     */
    "no": "no",

    /**
     * value: "neutral"
     * @const
     */
    "neutral": "neutral"
};


/**
 * Allowed values for the <code>first_purchase_timing</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['FirstPurchaseTimingEnum'] = {

    /**
     * value: "within_1m"
     * @const
     */
    "within_1m": "within_1m",

    /**
     * value: "within_3m"
     * @const
     */
    "within_3m": "within_3m",

    /**
     * value: "within_6m"
     * @const
     */
    "within_6m": "within_6m",

    /**
     * value: "within_1y"
     * @const
     */
    "within_1y": "within_1y",

    /**
     * value: "consult_planner"
     * @const
     */
    "consult_planner": "consult_planner"
};


/**
 * Allowed values for the <code>planner_comparison_count</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['PlannerComparisonCountEnum'] = {

    /**
     * value: "one"
     * @const
     */
    "one": "one",

    /**
     * value: "two_to_three"
     * @const
     */
    "two_to_three": "two_to_three",

    /**
     * value: "five_or_more"
     * @const
     */
    "five_or_more": "five_or_more",

    /**
     * value: "ten_or_more"
     * @const
     */
    "ten_or_more": "ten_or_more",

    /**
     * value: "consult_planner"
     * @const
     */
    "consult_planner": "consult_planner"
};


/**
 * Allowed values for the <code>meetingCheckItems</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['MeetingCheckItemsEnum'] = {

    /**
     * value: "monthly_real_cost"
     * @const
     */
    "monthly_real_cost": "monthly_real_cost",

    /**
     * value: "vacancy_cost"
     * @const
     */
    "vacancy_cost": "vacancy_cost",

    /**
     * value: "interest_rate_rise"
     * @const
     */
    "interest_rate_rise": "interest_rate_rise",

    /**
     * value: "rent_decline"
     * @const
     */
    "rent_decline": "rent_decline",

    /**
     * value: "repair_cost"
     * @const
     */
    "repair_cost": "repair_cost",

    /**
     * value: "sale_price"
     * @const
     */
    "sale_price": "sale_price",

    /**
     * value: "tax_effect"
     * @const
     */
    "tax_effect": "tax_effect",

    /**
     * value: "unfit_case"
     * @const
     */
    "unfit_case": "unfit_case",

    /**
     * value: "comparison"
     * @const
     */
    "comparison": "comparison",

    /**
     * value: "loan_consult"
     * @const
     */
    "loan_consult": "loan_consult",

    /**
     * value: "support_detail"
     * @const
     */
    "support_detail": "support_detail"
};


/**
 * Allowed values for the <code>explanationStyles</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['ExplanationStylesEnum'] = {

    /**
     * value: "beginner_friendly"
     * @const
     */
    "beginner_friendly": "beginner_friendly",

    /**
     * value: "with_numbers"
     * @const
     */
    "with_numbers": "with_numbers",

    /**
     * value: "risk_first"
     * @const
     */
    "risk_first": "risk_first",

    /**
     * value: "pros_cons"
     * @const
     */
    "pros_cons": "pros_cons",

    /**
     * value: "no_jargon"
     * @const
     */
    "no_jargon": "no_jargon",

    /**
     * value: "vs_other_investments"
     * @const
     */
    "vs_other_investments": "vs_other_investments",

    /**
     * value: "with_rationale"
     * @const
     */
    "with_rationale": "with_rationale",

    /**
     * value: "concise_points"
     * @const
     */
    "concise_points": "concise_points",

    /**
     * value: "own_pace"
     * @const
     */
    "own_pace": "own_pace",

    /**
     * value: "proactive_suggestion"
     * @const
     */
    "proactive_suggestion": "proactive_suggestion"
};


/**
 * Allowed values for the <code>anxiety_loan</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AnxietyLoanEnum'] = {

    /**
     * value: "strong"
     * @const
     */
    "strong": "strong",

    /**
     * value: "normal"
     * @const
     */
    "normal": "normal",

    /**
     * value: "weak"
     * @const
     */
    "weak": "weak"
};


/**
 * Allowed values for the <code>anxiety_vacancy</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AnxietyVacancyEnum'] = {

    /**
     * value: "strong"
     * @const
     */
    "strong": "strong",

    /**
     * value: "normal"
     * @const
     */
    "normal": "normal",

    /**
     * value: "weak"
     * @const
     */
    "weak": "weak"
};


/**
 * Allowed values for the <code>anxiety_exit</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AnxietyExitEnum'] = {

    /**
     * value: "strong"
     * @const
     */
    "strong": "strong",

    /**
     * value: "normal"
     * @const
     */
    "normal": "normal",

    /**
     * value: "weak"
     * @const
     */
    "weak": "weak"
};


/**
 * Allowed values for the <code>anxiety_repair</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AnxietyRepairEnum'] = {

    /**
     * value: "strong"
     * @const
     */
    "strong": "strong",

    /**
     * value: "normal"
     * @const
     */
    "normal": "normal",

    /**
     * value: "weak"
     * @const
     */
    "weak": "weak"
};


/**
 * Allowed values for the <code>anxiety_sales_pressure</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AnxietySalesPressureEnum'] = {

    /**
     * value: "strong"
     * @const
     */
    "strong": "strong",

    /**
     * value: "normal"
     * @const
     */
    "normal": "normal",

    /**
     * value: "weak"
     * @const
     */
    "weak": "weak"
};


/**
 * Allowed values for the <code>avoidSalesStyles</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AvoidSalesStylesEnum'] = {

    /**
     * value: "overpriced"
     * @const
     */
    "overpriced": "overpriced",

    /**
     * value: "tax_only"
     * @const
     */
    "tax_only": "tax_only",

    /**
     * value: "pushy_immediate"
     * @const
     */
    "pushy_immediate": "pushy_immediate",

    /**
     * value: "high_management"
     * @const
     */
    "high_management": "high_management",

    /**
     * value: "excessive_loan"
     * @const
     */
    "excessive_loan": "excessive_loan"
};


/**
 * Allowed values for the <code>customer_type</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['CustomerTypeEnum'] = {

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "long_term_hold"
     * @const
     */
    "long_term_hold": "long_term_hold",

    /**
     * value: "location_focused"
     * @const
     */
    "location_focused": "location_focused",

    /**
     * value: "yield_focused"
     * @const
     */
    "yield_focused": "yield_focused"
};


/**
 * Allowed values for the <code>core_goal</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['CoreGoalEnum'] = {

    /**
     * value: "retirement_income"
     * @const
     */
    "retirement_income": "retirement_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "family_protection"
     * @const
     */
    "family_protection": "family_protection",

    /**
     * value: "side_income"
     * @const
     */
    "side_income": "side_income",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "yield_improvement"
     * @const
     */
    "yield_improvement": "yield_improvement",

    /**
     * value: "loss_avoidance"
     * @const
     */
    "loss_avoidance": "loss_avoidance",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain"
};


/**
 * Allowed values for the <code>suitedAssets</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['SuitedAssetsEnum'] = {

    /**
     * value: "urban_used_kubun"
     * @const
     */
    "urban_used_kubun": "urban_used_kubun",

    /**
     * value: "new_kubun"
     * @const
     */
    "new_kubun": "new_kubun",

    /**
     * value: "renovated_kubun"
     * @const
     */
    "renovated_kubun": "renovated_kubun",

    /**
     * value: "urban_old_ittou"
     * @const
     */
    "urban_old_ittou": "urban_old_ittou",

    /**
     * value: "urban_new_ittou"
     * @const
     */
    "urban_new_ittou": "urban_new_ittou",

    /**
     * value: "rural_old_ittou"
     * @const
     */
    "rural_old_ittou": "rural_old_ittou",

    /**
     * value: "rural_new_ittou"
     * @const
     */
    "rural_new_ittou": "rural_new_ittou"
};


/**
 * Allowed values for the <code>avoidSalesStyleWarnings</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAgent['AvoidSalesStyleWarningsEnum'] = {

    /**
     * value: "overpriced"
     * @const
     */
    "overpriced": "overpriced",

    /**
     * value: "tax_only"
     * @const
     */
    "tax_only": "tax_only",

    /**
     * value: "pushy_immediate"
     * @const
     */
    "pushy_immediate": "pushy_immediate",

    /**
     * value: "high_management"
     * @const
     */
    "high_management": "high_management",

    /**
     * value: "excessive_loan"
     * @const
     */
    "excessive_loan": "excessive_loan"
};



export default InvestmentStyleDiagnosisAgent;

